import { apiClient, API_PATHS } from '@/services/api';

class UserSettingsService {
    async getAllSettings() {
        const response = await apiClient.rfp.get(API_PATHS.rfp.userSettings.all, {
            timeout: 10000,
        });

        return response.data?.data || null;
    }

    async getGroup(group) {
        const response = await apiClient.rfp.get(API_PATHS.rfp.userSettings.group(group), {
            timeout: 10000,
        });

        return response.data?.data || null;
    }

    async putGroup(group, value) {
        const response = await apiClient.rfp.put(
            API_PATHS.rfp.userSettings.group(group),
            { value },
            { timeout: 10000 }
        );

        return response.data?.data || null;
    }

    async patchGroup(group, merge) {
        const response = await apiClient.rfp.patch(
            API_PATHS.rfp.userSettings.group(group),
            { merge },
            { timeout: 10000 }
        );

        return response.data?.data || null;
    }

    async deleteGroupKey(group, key) {
        const response = await apiClient.rfp.delete(
            API_PATHS.rfp.userSettings.key(group, key),
            { timeout: 10000 }
        );

        return response.data?.data || null;
    }

    async getNavigationPreferences() {
        return this.getGroup('navigation');
    }

    async updateNavigationPreferences(preferences) {
        return this.putGroup('navigation', preferences);
    }

    async getFlags() {
        return this.getGroup('flags');
    }

    async updateFlags(merge) {
        return this.patchGroup('flags', merge);
    }
}

export const userSettingsService = new UserSettingsService();
